import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { AwardIcon, BookOpenIcon, CodeIcon } from 'lucide-react';
import { Badge } from '../../Badge';
const ITEMS: {
  icon: React.ReactNode;
  title: string;
  detail: string;
  status: string;
  accent: string;
}[] = [{
  icon: <CodeIcon className="h-5 w-5" aria-hidden="true" data-id="element-52" data-mp="3v2xdd6a31m1o" />,
  title: 'ソフトウェア開発経験',
  detail: '10年以上',
  status: '実務で培った技術',
  accent: 'bg-deep-navy text-white'
}, {
  icon: <AwardIcon className="h-5 w-5" aria-hidden="true" data-id="element-53" data-mp="mpq4er2n6q2u" />,
  title: 'AWS Certified AI Practitioner',
  detail: 'AIF-C01 保有',
  status: '取得済み',
  accent: 'bg-sage-green/15 text-sage-green'
}, {
  icon: <BookOpenIcon className="h-5 w-5" aria-hidden="true" data-id="element-54" data-mp="hwnin543wkx7" />,
  title: 'AWS Solutions Architect Associate',
  detail: 'SAA-C03 学習中',
  status: '取得に向けて研鑽中',
  accent: 'bg-amber/15 text-amber'
}];
export function Credentials() {
  const reduce = useReducedMotion();
  return <section id="credentials" className="w-full bg-surface-muted" data-id="element-55" data-mp="1af15k9nwmmhi">
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-24" data-id="element-56" data-mp="2u2m99zuvgk06">
        <div className="text-center" data-id="element-57" data-mp="2p3j5sjujilub">
          <div className="flex justify-center" data-id="element-58" data-mp="2p4ku3q0kh4tz">
            <Badge variant="amber" style={{
            color: '#E09A3B',
            backgroundColor: 'rgba(224, 154, 59, 0.15)',
            borderColor: 'rgba(224, 154, 59, 0.3)'
          }} className="border" data-id="element-59" data-mp="32uoa3z8us2az">
              専門性の裏づけ
            </Badge>
          </div>
          <h2 className="mt-4 font-heading text-2xl font-bold text-text sm:text-3xl" data-id="element-60" data-mp="37spr8empxrjt">
            確かな技術で、安心してお任せいただくために
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-text" data-id="element-61" data-mp="3hrfcmhdtpu4t">
            華やかな実績はこれから。その分、技術の裏づけと日々の学びは正直にお見せします。
          </p>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-62" data-mp="1rfhp8l4y0bq0">
          {ITEMS.map((it, i) => <motion.div key={it.title} initial={reduce ? undefined : {
          opacity: 0,
          y: 18
        }} whileInView={reduce ? undefined : {
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className="flex h-full flex-col rounded-2xl border border-border bg-white p-6" data-id="element-63" data-mp="1neywmov871mr" data-mpi={i}>
              <span className={`inline-flex h-11 w-11 items-center justify-center rounded-lg ${it.accent}`} data-id="element-64" data-mp="o0ijpvkmhqhe">
                {it.icon}
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-text" data-id="element-65" data-mp="sxs95b80i258">
                {it.title}
              </h3>
              <p className="mt-1 text-lg font-bold text-text" data-id="element-66" data-mp="2hjqzvmi52ns6">{it.detail}</p>
              <p className="mt-auto pt-3 text-xs font-medium text-text-muted" data-id="element-67" data-mp="2dhnmgsbwt949">
                {it.status}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}